export default function (state) {
    //добавить для всех
    let list = state.items.concat([]);
    list.sort((a, b) => {
        // if (a.main) return -1;
        // if (b.main) return 1;
        return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    })
    list.unshift({value: 0, label: "Для всех"});
    return list;
}
